import React from 'react';
import {getImageUrl} from '../utils';
import {getOptImage} from 'epic-ue-shared';

interface Properties {
    item: any;
    itemSize: number;
}

const FeedImage = (props: Properties): JSX.Element => {
    const item = props.item || {};
    const imageUrl = getImageUrl(item);

    const itemSize = props.itemSize;
    let w = 800;
    switch (itemSize) {
        case 33:
            w = 500;
            break;
        case 66:
            w = 800;
            break;
        case 100:
            w = 1400;
        default:
            w = 800;
            break;
    }

    const bkImageStyle = imageUrl
        ? {backgroundImage: `url(${getOptImage({url: imageUrl, width: w})})`}
        : {};

    return (
        <div className="image-wrapper">
            <div className="image" style={bkImageStyle} />
        </div>
    );
};

export default FeedImage;
